export const environment = {
  production: true,
  contactURL: 'https://contactv2-rz7szkuosq-uc.a.run.app',
  analyticsEnabled: true,
  cookieDomain: 'nhdsgn.com',
};
